// Typelizer digest 85a9fa9e7e84e588310982cffa63de13
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/payments/:payment_id/counterparties/:id */
  update: (
    params: { paymentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/counterparties/:id', params, options),
    method: 'patch',
  }),
}
